module.exports = __webpack_public_path__ + "img/holiday01.44c7c024.png";